import { createApi } from '@reduxjs/toolkit/query/react'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

export const PackagesAPI = createApi({
  reducerPath: 'PackagesAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['PackagesAPI'],
  endpoints: builder => ({
    showAllFlightCompanies: builder.query({
      query: () => ({
        url: `/api/Flights/companies`,
        method: 'GET',
        headers: authHeaderAPI(),
      }),
      providesTags: ['PackagesAPI'],
    }),
    showAllPackages: builder.query({
      query: (params: any) => ({
        url: `/api/Packages`,
        method: 'GET',
        headers: authHeaderAPI(),
        params,
      }),
      providesTags: ['PackagesAPI'],
    }),
    addPackage: builder.mutation<any, any>({
      query: (body: any) => ({
        url: `/api/Packages`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['PackagesAPI'],
    }),
    getPackageById: builder.query({
      query: id => ({
        url: `/api/Packages/${id}`,
        method: 'GET',
        headers: authHeaderAPI(),
      }),
      providesTags: ['PackagesAPI'],
    }),
    updatePackage: builder.mutation<any, any>({
      query: ({ body, id }) => ({
        url: `/api/Packages/${id}`,
        method: 'PUT',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['PackagesAPI'],
    }),
    deletePackage: builder.mutation<any, any>({
      query: id => ({
        url: `/api/Packages/${id}`,
        method: 'DELETE',
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['PackagesAPI'],
    }),
  }),
})

export const {
  useShowAllFlightCompaniesQuery,
  useAddPackageMutation,
  useGetPackageByIdQuery,
  useDeletePackageMutation,
  useUpdatePackageMutation,
  useShowAllPackagesQuery,
} = PackagesAPI
